import type { DateTime } from 'luxon';

export function getNthWeekdayOfMonth(date: DateTime) {
  const normalizedDate = date.startOf('day');
  const dayOfWeek = normalizedDate.weekday;
  const firstDayOfMonth = normalizedDate.startOf('month');
  const daysUntilFirstTargetDay = (dayOfWeek - firstDayOfMonth.weekday + 7) % 7;
  const firstTargetDay = firstDayOfMonth.plus({
    days: daysUntilFirstTargetDay,
  });

  return Math.ceil(normalizedDate.diff(firstTargetDay, 'days').days / 7) + 1;
}
